export const validationMessages = {
  titleError:
    'Hmm, looks like we’re missing something. Can you let us know your title then try again?',
  titleMismatchError: 'Please confirm if your title and gender are both correct on 0800 121 7365.',
  firstNameError:
    'Ah, that didn’t work. Try entering your first name using only letters, spaces, hyphens and dashes.',
  middleNameError:
    'Ah, that didn’t work. Try entering your middle name using only letters, spaces, hyphens and dashes.',
  lastNameError:
    'Ah, that didn’t work. Try entering your last name using only letters, spaces, hyphens and dashes.',
  genderError:
    'Hmm, looks like we’re missing something. Can you choose one of the options then try again?',
  birthDate: {
    dobError: 'Ah, that didn’t work. Try entering your date of birth using the format DD MM YYYY.',
    minimumAgeError: 'Sorry, you need to be at least 18 to open an account online.',
    maximumAgeError: 'Please enter a valid date of birth.'
  },
  maritalStatusError:
    'Hmm, looks like we’re missing something. Can you choose your marital status then try again?',
  noOfDependentError:
    'Hmm, looks like we’re missing something. Can you choose how many dependants you have then try again?',
  genericError: 'Please select from the given list.',
  UKCitizenshipError:
    'Hmm, looks like we’re missing something. Can you let us know if you’re a UK national then try again?',
  otherCountryCitizenshipError:
    'Hmm, looks like we’re missing something. Can you let us know your nationality then try again?',
  emailAddressError: `Hmm. Can you double check your email address? There might be a typo in there somewhere.`,
  mobileNumberError: `Ah, that didn’t work. Your mobile number must start with 07 and it should be 11 digits long using numbers only. We need this so you can access internet and telephone banking.`
};
